export const ru = {
    newGroup: 'Новая группа'
};
